export default __webpack_public_path__ + "static/media/antelope-4-thumbnail.3c8e9713.webp";